module.exports = __webpack_public_path__ + "static/media/gabe_brown.02003fba.jpeg";